(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[16068],{

/***/ 19114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DebtReliefProcessLike; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/style.module.scss
var style_module = __webpack_require__(64777);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
// EXTERNAL MODULE: ./src/components/nomoredebttoday/sharedButton/index.tsx
var sharedButton = __webpack_require__(78678);
;// CONCATENATED MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/icons/comprehensiveFinancialAssessment.tsx


function ComprehensiveFinancialAssessment() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "51",
        height: "50",
        fill: "none",
        viewBox: "0 0 51 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M21.703 33.146a4.904 4.904 0 01-2.72-.823 4.871 4.871 0 01-.742-7.512 4.899 4.899 0 015.335-1.058c.894.37 1.659.995 2.197 1.798.537.803.825 1.747.825 2.713a4.881 4.881 0 01-1.436 3.45 4.907 4.907 0 01-3.459 1.432zm0-7.841a2.973 2.973 0 00-2.741 1.826 2.953 2.953 0 00.643 3.226 2.969 2.969 0 003.233.64 2.966 2.966 0 001.831-2.733c0-.785-.313-1.537-.87-2.091a2.974 2.974 0 00-2.096-.868zM42.285 13.963a.973.973 0 01-.216-.023l-4.296-.981a.965.965 0 01-.723-.721l-.988-4.288a.96.96 0 01.258-.895L43.115.281a.965.965 0 011.645.651l.128 4.207 4.218.128a.966.966 0 01.87.607.958.958 0 01-.218 1.037l-6.791 6.771a.965.965 0 01-.682.281zm-3.492-2.745l3.187.728 4.837-4.825-2.892-.087a.965.965 0 01-.934-.932l-.088-2.885-4.837 4.825.727 3.176z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M21.703 29.225a.966.966 0 01-.89-.593.96.96 0 01.208-1.048l16.285-16.242A.963.963 0 1138.67 12.7L22.385 28.944a.966.966 0 01-.682.281z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M21.703 50a21.76 21.76 0 01-14.569-5.617A21.632 21.632 0 014.252 15.45a21.735 21.735 0 0113.176-8.366 21.777 21.777 0 0115.399 2.611 21.682 21.682 0 019.664 12.239 21.62 21.62 0 01-1.063 15.543A21.704 21.704 0 0130.186 48.29 21.7 21.7 0 0121.703 50zm0-41.55c-10.953 0-19.865 8.89-19.865 19.814s8.912 19.813 19.865 19.813c10.954 0 19.864-8.889 19.864-19.813 0-10.925-8.911-19.813-19.864-19.813z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M21.703 44.726a16.53 16.53 0 01-10.47-3.736 16.454 16.454 0 01-5.718-9.513 16.424 16.424 0 011.631-10.971 16.49 16.49 0 018.24-7.45 16.545 16.545 0 0111.106-.545 16.502 16.502 0 018.933 6.607 16.43 16.43 0 01-2.05 20.786 16.436 16.436 0 01-11.671 4.823zm0-31.002c-8.038 0-14.578 6.523-14.578 14.54 0 8.016 6.54 14.54 14.578 14.54S36.28 36.28 36.28 28.263c0-8.018-6.54-14.54-14.577-14.54z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M21.703 39.453c-6.187 0-11.218-5.018-11.218-11.19 0-6.17 5.03-11.188 11.218-11.188s11.218 5.019 11.218 11.189-5.032 11.189-11.218 11.189zm0-20.455c-5.121 0-9.29 4.157-9.29 9.265 0 5.11 4.167 9.267 9.29 9.267 5.123 0 9.29-4.157 9.29-9.267 0-5.109-4.168-9.265-9.29-9.265z"
            })
        ]
    });
}
/* harmony default export */ var comprehensiveFinancialAssessment = (ComprehensiveFinancialAssessment);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/icons/personalizedDebtReliefPlan.tsx


function PersonalizedDebtReliefPlan() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "55",
        height: "50",
        fill: "none",
        viewBox: "0 0 55 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#B6E7FF",
                clipPath: "url(#clip0_1_141)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M.796 50.001a.793.793 0 01-.563-.236.81.81 0 01-.233-.569V10.37a.804.804 0 01.23-.568l4.707-4.807L9.697.23a.79.79 0 01.563-.233h28.156c.21 0 .413.085.562.236a.81.81 0 01.234.569v7.246l.32.154a12.3 12.3 0 014.884 4.242 12.56 12.56 0 012.02 8.559 12.498 12.498 0 01-4.08 7.773l-.375.331 3.075 4.579.313-.014h.107c.407 0 .809.1 1.169.293.36.192.668.471.897.812l6.249 9.306a2.515 2.515 0 01.386 1.893 2.517 2.517 0 01-1.05 1.61 2.459 2.459 0 01-1.397.435c-.407 0-.808-.101-1.167-.294a2.502 2.502 0 01-.896-.813l-6.25-9.306a2.523 2.523 0 01-.21-2.448l.127-.284-3.075-4.58-.442.228c-.094.05-.188.095-.288.145l-.32.154v18.372a.81.81 0 01-.233.57.793.793 0 01-.562.235H.796zm.796-1.61h36.026V31.419l-.685.155c-.882.2-1.783.3-2.687.3a12.216 12.216 0 01-5.776-1.442 12.363 12.363 0 01-4.433-4.01 12.427 12.427 0 01-1.872-4.469c-.325-1.6-.334-3.249-.025-4.852a12.43 12.43 0 011.798-4.503 12.295 12.295 0 013.375-3.455 12.117 12.117 0 019.228-1.92c.116.023.24.05.391.083l.686.155V1.613H10.584v8.708c0 .1-.039.197-.11.268a.373.373 0 01-.264.11H1.593v37.693zM34.2 8.982a10.185 10.185 0 00-5.782 1.798 10.327 10.327 0 00-2.836 2.902 10.442 10.442 0 00-1.51 3.783 10.492 10.492 0 00.019 4.08 10.444 10.444 0 005.296 7.125 10.26 10.26 0 004.851 1.213 10.202 10.202 0 005.795-1.799 10.473 10.473 0 004.347-6.686 10.555 10.555 0 00-1.596-7.835 10.328 10.328 0 00-2.873-2.866 10.216 10.216 0 00-3.743-1.527 10.423 10.423 0 00-1.968-.188zM6.067 6.129L2.336 9.94h7.5V2.36L6.066 6.129z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.57 17.017H6.91v.757h9.66v-.758zM16.57 23.173H6.91v.757h9.66v-.757zM16.57 29.328H6.91v.757h9.66v-.757zM32.449 35.484H6.91v.757H32.45v-.757zM32.449 41.64H6.91v.757H32.45v-.758z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_141",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H54.225V50H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var personalizedDebtReliefPlan = (PersonalizedDebtReliefPlan);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/icons/companyCommunicates.tsx


function CompanyCommunicates() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "51",
        height: "50",
        fill: "none",
        viewBox: "0 0 51 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M49.238 20h-4.803a19.799 19.799 0 00-2.137-5.156l3.397-3.397a.834.834 0 000-1.179l-5.892-5.892a.833.833 0 00-1.179 0l-3.397 3.397a19.824 19.824 0 00-5.156-2.137V.833A.834.834 0 0029.238 0h-8.334a.833.833 0 00-.833.833v4.803a19.824 19.824 0 00-5.156 2.137l-3.397-3.397a.833.833 0 00-1.179 0l-5.892 5.892a.833.833 0 000 1.179l3.397 3.397A19.799 19.799 0 005.707 20H.904a.833.833 0 00-.833.833v8.334A.833.833 0 00.904 30h4.803a19.799 19.799 0 002.137 5.156l-3.397 3.397a.833.833 0 000 1.179l5.892 5.892a.833.833 0 001.179 0l3.397-3.397a19.827 19.827 0 005.156 2.137v4.803a.833.833 0 00.833.833h8.334a.833.833 0 00.833-.833v-4.803a19.826 19.826 0 005.156-2.137l3.397 3.397a.833.833 0 001.179 0l5.892-5.892a.834.834 0 000-1.179l-3.397-3.397A19.799 19.799 0 0044.435 30h4.803a.833.833 0 00.833-.833v-8.334a.834.834 0 00-.833-.833zm-.834 8.333h-4.626a.833.833 0 00-.814.654 18.165 18.165 0 01-2.424 5.846.833.833 0 00.114 1.037l3.274 3.273-4.714 4.714-3.274-3.274a.833.833 0 00-1.036-.113 18.203 18.203 0 01-5.847 2.424.833.833 0 00-.653.814v4.625h-6.666v-4.625a.833.833 0 00-.653-.814 18.203 18.203 0 01-5.847-2.424.833.833 0 00-1.037.113l-3.273 3.273-4.714-4.714 3.274-3.273a.834.834 0 00.114-1.036 18.167 18.167 0 01-2.424-5.846.833.833 0 00-.814-.654H1.738v-6.666h4.626a.833.833 0 00.814-.654 18.166 18.166 0 012.424-5.846.833.833 0 00-.114-1.037l-3.274-3.273 4.714-4.713 3.274 3.273a.833.833 0 001.037.113 18.204 18.204 0 015.846-2.424.833.833 0 00.653-.813V1.667h6.666v4.626a.833.833 0 00.653.813c2.076.46 4.055 1.28 5.847 2.424a.833.833 0 001.037-.113l3.273-3.273 4.715 4.713-3.275 3.274a.833.833 0 00-.114 1.037 18.166 18.166 0 012.424 5.845.833.833 0 00.814.654h4.626v6.666z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M25.071 10a15 15 0 1015 15 15.018 15.018 0 00-15-15zm0 28.333A13.334 13.334 0 1138.404 25a13.35 13.35 0 01-13.333 13.333z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M30.578 20.316l-7.599 7.6-3.416-3.416a.835.835 0 00-1.433.586.831.831 0 00.254.592l4.005 4.007a.834.834 0 001.179 0l8.188-8.19a.834.834 0 10-1.178-1.178v-.001z"
            })
        ]
    });
}
/* harmony default export */ var companyCommunicates = (CompanyCommunicates);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/icons/fundSettlements.tsx


function FundSettlements() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "50",
        fill: "none",
        viewBox: "0 0 64 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M28.381 32.424c-1.094 0-1.983-.752-1.983-1.71 0-.957.89-1.71 1.983-1.71 1.095 0 1.984.753 1.984 1.71 0 .547.479 1.026 1.026 1.026s1.026-.479 1.026-1.026c0-1.778-1.3-3.214-3.01-3.624V25.31c0-.547-.478-1.025-1.026-1.025-.547 0-1.025.478-1.025 1.025v1.779c-1.71.41-3.01 1.915-3.01 3.624 0 2.12 1.779 3.762 4.035 3.762 1.095 0 1.984.752 1.984 1.71 0 .957-.89 1.71-1.983 1.71-1.095 0-1.984-.753-1.984-1.71 0-.548-.479-1.026-1.026-1.026s-1.025.478-1.025 1.025c0 1.779 1.299 3.215 3.009 3.625v1.778c0 .547.478 1.026 1.025 1.026.548 0 1.026-.479 1.026-1.026V39.81c1.71-.41 3.01-1.915 3.01-3.625 0-2.051-1.847-3.761-4.036-3.761z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M55.737 50H1.026A1.052 1.052 0 010 48.974V17.857c0-.547.479-1.026 1.026-1.026h54.711c.547 0 1.026.479 1.026 1.026v31.117c0 .616-.479 1.026-1.026 1.026zM2.052 47.948h52.66V18.883H2.051v29.065z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M47.12 45.76h-6.428a1.052 1.052 0 01-1.026-1.026c0-.547.479-1.026 1.026-1.026h6.018l3.898-3.35V26.542L46.71 23.19h-6.018a1.052 1.052 0 01-1.026-1.025c0-.547.479-1.026 1.026-1.026h6.428c.274 0 .479.068.684.273l4.514 3.898c.205.206.342.48.342.753v14.772c0 .273-.137.547-.342.752l-4.514 3.898c-.205.206-.41.274-.684.274zM16.072 45.76h-6.43c-.273 0-.478-.069-.683-.274l-4.514-3.898c-.205-.205-.342-.479-.342-.752V26.064c0-.274.137-.616.342-.753l4.514-3.898c.205-.137.41-.273.684-.273h6.428c.548 0 1.026.479 1.026 1.026s-.478 1.025-1.026 1.025h-6.018l-3.898 3.352v13.814l3.898 3.351h6.018c.548 0 1.026.479 1.026 1.026s-.478 1.026-1.026 1.026z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M28.381 45.76c-6.77 0-12.31-5.54-12.31-12.31 0-6.77 5.54-12.31 12.31-12.31 6.771 0 12.31 5.54 12.31 12.31 0 6.77-5.539 12.31-12.31 12.31zm0-22.569A10.245 10.245 0 0018.123 33.45a10.245 10.245 0 0010.258 10.258A10.245 10.245 0 0038.64 33.45 10.245 10.245 0 0028.38 23.19zM29.065 16.147h2.941c.137-.068.274-.068.41-.068.343-.069.684 0 1.026.068h2.873c-.547-1.162-1.778-1.983-3.146-2.12l-.274-1.71c-.068-.547-.615-.957-1.162-.889-.547.069-.958.616-.89 1.163l.274 1.71c-.889.41-1.573 1.094-2.052 1.846z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M63.465 31.672L58.883.897c-.068-.548-.615-.958-1.163-.89L3.556 8.146c-.547.068-.957.615-.82 1.162l.957 6.84h2.052l-.89-6.156 52.113-7.796 4.309 28.723-3.83.547v2.052l5.13-.752c.546 0 .957-.479.888-1.094z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B6E7FF",
                d: "M43.77 8.556l5.949-.889 4.309 2.736.889 5.744h.82c.547 0 1.026.274 1.3.616l-1.095-7.181c-.068-.274-.205-.547-.478-.684l-5.061-3.214c-.205-.137-.479-.205-.684-.137l-6.36.958c-.547.068-.958.615-.89 1.162.206.616.685.958 1.3.89zM23.8 16.147c1.436-3.009 4.24-5.266 7.727-5.813 4.582-.684 8.891 1.778 10.806 5.813h2.257c-1.984-5.266-7.523-8.685-13.336-7.796-4.582.684-8.138 3.761-9.711 7.796h2.256zM10.737 16.147l2.667-3.077 5.95-.89c.547-.068.958-.615.89-1.162-.07-.547-.616-.957-1.163-.889l-6.36.957c-.274.069-.48.137-.616.342l-3.898 4.514c-.069.069-.069.137-.137.205h2.667z"
            })
        ]
    });
}
/* harmony default export */ var fundSettlements = (FundSettlements);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/icons/processUnfolds.tsx


function ProcessUnfolds() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        fill: "none",
        viewBox: "0 0 50 50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#B6E7FF",
            d: "M49.774 28.344a24.92 24.92 0 01-5.606 12.7A24.835 24.835 0 0127.21 49.9c-.754.067-1.506.1-2.254.1a24.781 24.781 0 01-15.167-5.162l.256 2.88a.977.977 0 01-1.946.172l-.474-5.347a.977.977 0 01.886-1.06l5.347-.474a.976.976 0 11.172 1.945l-3.125.278a22.847 22.847 0 0014.054 4.815c.69 0 1.383-.03 2.078-.093a22.894 22.894 0 0015.635-8.164c5.65-6.75 6.968-15.96 3.441-24.033a.976.976 0 011.79-.782 25.073 25.073 0 011.872 13.369zM38.991 6.69l-2.956.262a.977.977 0 00.172 1.946l5.348-.475a.977.977 0 00.886-1.06l-.475-5.346a.977.977 0 00-1.946.173l.27 3.036C35.294 1.356 29.118-.462 22.788.1a24.835 24.835 0 00-16.96 8.856 24.92 24.92 0 00-5.606 12.7c-.609 4.548.039 9.17 1.872 13.369a.976.976 0 101.79-.782C.358 26.169 1.676 16.96 7.326 10.21 15.26.727 29.264-.75 38.99 6.69zm-6.64 18.278c0 4.035-3.282 7.317-7.316 7.317s-7.316-3.282-7.316-7.317c0-4.034 3.282-7.316 7.316-7.316s7.316 3.282 7.316 7.316zm-1.952 0a5.37 5.37 0 00-5.364-5.363 5.37 5.37 0 00-5.364 5.363 5.37 5.37 0 005.364 5.364 5.37 5.37 0 005.364-5.364zm6.587 4.95c-.294.709-.314 1.76.511 2.585a1.973 1.973 0 010 2.787l-2.14 2.14a1.973 1.973 0 01-2.787 0c-.825-.825-1.877-.805-2.585-.511-.709.293-1.466 1.023-1.466 2.19 0 1.086-.884 1.97-1.971 1.97h-3.027a1.973 1.973 0 01-1.97-1.97c0-1.17-.757-1.9-1.465-2.192-.708-.294-1.76-.313-2.587.514a1.956 1.956 0 01-1.393.577 1.958 1.958 0 01-1.393-.577l-2.14-2.14a1.973 1.973 0 010-2.787c.825-.825.805-1.877.511-2.585-.293-.71-1.023-1.466-2.19-1.466a1.973 1.973 0 01-1.97-1.971v-3.027c0-1.086.884-1.97 1.97-1.97 1.167 0 1.897-.758 2.19-1.466.294-.709.314-1.76-.511-2.586a1.973 1.973 0 010-2.787l2.14-2.14a1.958 1.958 0 011.393-.577c.527 0 1.022.205 1.393.577.826.825 1.877.806 2.586.512.708-.294 1.466-1.023 1.466-2.19 0-1.087.884-1.97 1.97-1.97h3.027c1.087 0 1.97.883 1.97 1.97 0 1.167.758 1.896 1.467 2.19.708.293 1.76.313 2.585-.512a1.973 1.973 0 012.787 0l2.14 2.14a1.973 1.973 0 010 2.787c-.825.825-.805 1.877-.511 2.586.293.708 1.023 1.466 2.19 1.466 1.086 0 1.97.884 1.97 1.97v3.027c0 1.086-.884 1.97-1.97 1.97-1.168 0-1.897.757-2.19 1.466zm2.19-3.419c.01 0 .017-.008.017-.017v-3.027a.018.018 0 00-.018-.018c-1.78 0-3.312-1.023-3.994-2.671-.682-1.648-.324-3.455.936-4.714a.018.018 0 000-.025l-2.14-2.14a.018.018 0 00-.026 0c-1.26 1.259-3.065 1.618-4.713.935-1.648-.682-2.672-2.213-2.672-3.994a.017.017 0 00-.017-.018h-3.027a.018.018 0 00-.017.018c0 1.78-1.024 3.311-2.672 3.994-1.648.683-3.454.325-4.714-.935-.006-.006-.019-.006-.025 0l-2.14 2.14a.018.018 0 000 .025c1.26 1.26 1.618 3.066.935 4.714-.682 1.648-2.212 2.671-3.994 2.671a.018.018 0 00-.017.018v3.027c0 .01.007.017.017.017 1.781 0 3.312 1.024 3.994 2.672.682 1.648.324 3.454-.935 4.714a.017.017 0 000 .025l2.14 2.14c.006.006.02.006.025 0a4.267 4.267 0 013.032-1.278c.56 0 1.13.112 1.683.34 1.647.683 2.67 2.214 2.67 3.997 0 .01.008.017.018.017h3.027c.01 0 .017-.007.017-.017 0-1.781 1.024-3.312 2.672-3.995 1.647-.682 3.453-.324 4.713.936a.018.018 0 00.025 0l2.14-2.14a.017.017 0 000-.025c-1.259-1.26-1.617-3.066-.935-4.714.683-1.648 2.214-2.672 3.994-2.672z"
        })
    });
}
/* harmony default export */ var processUnfolds = (ProcessUnfolds);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/DebtReliefProcessLike/index.tsx










const DebtReliefProcessLikeList = [
    {
        description: "It begins with a comprehensive financial assessment, evaluating the client's debts, income, and financial goals",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensiveFinancialAssessment, {})
    },
    {
        description: "Based on this assessment, a personalized debt relief plan is created, which may include debt settlement negotiations, debt consolidation, credit counseling, or bankruptcy",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(personalizedDebtReliefPlan, {})
    },
    {
        description: "Throughout the process, the debt relief company communicates with creditors to negotiate favorable terms, such as reduced balances or interest rates",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(companyCommunicates, {})
    },
    {
        description: "Clients are often required to make regular payments into a dedicated account to fund settlements or consolidated payments",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fundSettlements, {})
    },
    {
        description: "As the process unfolds, clients can see their debt gradually decrease, ultimately leading to a more manageable financial situation and, in some cases, becoming debt-free",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(processUnfolds, {})
    }, 
];
function DebtReliefProcessLike() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).mainContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:pt-[97px] lg:pb-[142px] pt-[92px] pb-[82px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
                    featureList: DebtReliefProcessLikeList,
                    mainTitle: "What Is the Debt Relief Process Like?",
                    mainDescription: "The debt relief process typically involves several key steps aimed at helping individuals regain financial stability.",
                    colors: {
                        mainTitleColor: "white",
                        descriptionColor: "white",
                        mainDescriptionColor: "white"
                    },
                    classes: {
                        mainSectionClasses: "  ",
                        mainTitleClasses: " text-2xl  lg:text-3xl font-bold text-center sm:text-left",
                        mainDescriptionClasses: "mt-[20px] lg:text-xl lg:leading-8 text-center sm:text-left leading-7 font-semibold",
                        innerSectionClasses: "flex   flex-wrap   sm:gap-[88px] gap-[60px] mt-[50px] ",
                        oneBoxClasses: "  w-full max-w-[350px] mx-auto sm:mx-0 sm:w-[300px] ",
                        iconClasses: "children:mx-auto sm:children:mx-0 ",
                        descriptionClasses: `font-light text-center sm:text-left `
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "lg:text-xl lg:leading-8 text-center sm:text-left leading-7 font-semibold text-[#fff] lg:mt-[70px] mt-8",
                    children: "Open communication with the debt relief company is essential to ensuring a successful outcome."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-5 text-center sm:text-left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                })
            ]
        })
    });
}


/***/ }),

/***/ 25622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DebtReliefCompanyBenefit; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22950);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78678);




function DebtReliefCompanyBenefit() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: ` lg:mt-28 mt-16 md:p-20 py-10 px-5 ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().mainSection)} lg:mb-[200px] mb-[100px]`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " mx-auto text-[#fff] sm:text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "font-bold lg:text-3xl text-xl lg:leading-[45px] ",
                    children: "How Can a Debt Relief Company Benefit You?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                    children: "A debt relief company can offer some major benefits to folks dealing with overwhelming debt. These companies specialize in negotiating with creditors for reduced debt amounts, lower interest rates, or more manageable repayment terms. With their help, you can find relief from the stress and burden of unmanageable debt."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "lg:mt-10 mt-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                })
            ]
        })
    });
}


/***/ }),

/***/ 41968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GoodDebtReliefCompany; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/nomoredebttoday/goodDebtReliefCompany/icons/severalKeyFactors.tsx


function SeveralKeyFactors() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#12366D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.678 15.91h-4.193v-1.648a.445.445 0 00-.433-.433h-9.02a.445.445 0 00-.435.433v1.62h-4.192a.445.445 0 00-.434.433v23.968c0 .232.203.434.434.434h18.273a.445.445 0 00.433-.434V16.344a.445.445 0 00-.433-.434zm-13.213-1.214h8.182v3.267h-8.182v-3.267zM36.244 39.85H18.839V16.778h3.73v1.619c0 .231.202.433.433.433h9.05a.445.445 0 00.433-.433v-1.62h3.73V39.85h.029z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M33.758 32.708H21.325a.445.445 0 00-.433.434v3.354c0 .231.202.434.433.434H33.73a.445.445 0 00.433-.434v-3.354c.03-.231-.173-.434-.404-.434zm-.434 3.354H21.759v-2.486h11.565v2.486zM33.758 26.926H21.325a.445.445 0 00-.433.434v3.353c0 .232.202.434.433.434H33.73a.445.445 0 00.433-.434V27.36c.03-.232-.173-.434-.404-.434zm-.434 3.354H21.759v-2.487h11.565v2.487zM20.892 21.577v3.354c0 .231.202.434.433.434H33.73a.445.445 0 00.433-.434v-3.354a.445.445 0 00-.433-.434H21.325a.445.445 0 00-.433.434zm.867.434h11.565v2.486H21.759v-2.486z"
            })
        ]
    });
}
/* harmony default export */ var severalKeyFactors = (SeveralKeyFactors);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/goodDebtReliefCompany/icons/accreditationFromIndustry.tsx


function AccreditationFromIndustry() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#12366D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M15.918 39.63a.383.383 0 01-.371-.476l1.539-6.047c-1.287-.868-2.308-1.875-3.037-2.995-.81-1.245-1.22-2.572-1.22-3.944 0-2.663 1.553-5.154 4.372-7.017 2.771-1.83 6.448-2.837 10.353-2.837 3.905 0 7.582 1.008 10.353 2.837 2.82 1.863 4.372 4.355 4.372 7.017 0 2.663-1.553 5.155-4.372 7.017-2.771 1.83-6.448 2.837-10.353 2.837-1.984 0-3.906-.257-5.717-.767l-5.688 4.298a.385.385 0 01-.231.078zm11.636-22.55c-7.697 0-13.96 4.077-13.96 9.088 0 2.434 1.47 4.724 4.138 6.448a.382.382 0 01.162.416l-1.336 5.253 4.97-3.756a.385.385 0 01.34-.062c1.795.524 3.708.79 5.687.79 7.697 0 13.96-4.077 13.96-9.089 0-5.011-6.263-9.089-13.96-9.089z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M21.778 28.749a.384.384 0 01-.178-.044l-1.666-.876-1.665.876a.382.382 0 01-.555-.404l.318-1.854-1.348-1.314a.383.383 0 01.212-.653l1.863-.27.832-1.687a.383.383 0 01.687 0l.833 1.687 1.862.27a.383.383 0 01.212.653l-1.348 1.314.318 1.854a.383.383 0 01-.377.448zm-1.844-1.735c.062 0 .123.015.178.044l1.158.608-.221-1.288a.384.384 0 01.11-.34l.936-.912-1.294-.188a.383.383 0 01-.288-.21l-.579-1.172-.578 1.173a.383.383 0 01-.288.21l-1.294.187.936.913c.09.088.131.215.11.339l-.221 1.288 1.157-.608a.382.382 0 01.178-.044zM29.495 28.749a.384.384 0 01-.178-.044l-1.665-.876-1.666.876a.382.382 0 01-.555-.404l.318-1.854-1.347-1.314a.382.382 0 01.212-.653l1.862-.27.833-1.687a.383.383 0 01.686 0l.833 1.687 1.861.27a.383.383 0 01.212.653l-1.347 1.314.318 1.854a.382.382 0 01-.377.448zm-1.843-1.735c.061 0 .122.015.178.044l1.157.608-.221-1.288a.384.384 0 01.11-.34l.936-.912-1.293-.188a.382.382 0 01-.288-.21l-.579-1.172-.58 1.173a.38.38 0 01-.287.21l-1.294.188.937.912c.09.088.13.215.11.34l-.222 1.288 1.157-.609a.38.38 0 01.18-.044zM37.213 28.749a.386.386 0 01-.178-.044l-1.666-.876-1.665.876a.382.382 0 01-.555-.404l.318-1.854-1.347-1.314a.384.384 0 01.211-.653l1.862-.27.833-1.687a.383.383 0 01.687 0l.833 1.687 1.862.27a.383.383 0 01.211.653l-1.348 1.314.319 1.854a.384.384 0 01-.377.448zm-1.844-1.735a.38.38 0 01.178.044l1.157.608-.22-1.288a.383.383 0 01.11-.34l.935-.912-1.293-.188a.38.38 0 01-.288-.21l-.58-1.172-.578 1.173a.38.38 0 01-.288.21l-1.294.187.937.913c.09.088.13.215.11.339l-.221 1.288 1.157-.608a.384.384 0 01.178-.044z"
            })
        ]
    });
}
/* harmony default export */ var accreditationFromIndustry = (AccreditationFromIndustry);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/goodDebtReliefCompany/icons/transparentAndReasonable.tsx


function TransparentAndReasonable() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#12366D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M19.692 13.956h1.116V13h-2.072v2.071h.956v-1.115zM38.456 13h-2.941v.956h2.941V13zM25.218 13h-2.941v.956h2.941V13zM29.632 13H26.69v.956h2.942V13zM34.046 13h-2.942v.956h2.942V13zM39.928 13v.956h1.116v1.115H42V13h-2.072zM42 25.368h-.956v2.942H42v-2.942zM42 20.954h-.956v2.942H42v-2.942zM42 29.782h-.956v2.941H42v-2.941zM42 16.544h-.956v2.941H42v-2.941zM41.044 35.308h-1.115v.956H42v-2.072h-.956v1.116zM25.218 35.308h-2.941v.956h2.941v-.956zM34.046 35.308h-2.942v.956h2.942v-.956zM29.632 35.308H26.69v.956h2.942v-.956zM20.808 35.308h-1.116v-1.116h-.956v2.072h2.072v-.956zM19.692 29.782h-.956v2.941h.956v-2.941zM19.692 20.954h-.956v2.942h.956v-2.942zM19.692 25.368h-.956v2.942h.956v-2.942z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.264 18.736H19.692v-2.192h-.956v2.192H13V42h23.264v-5.736h2.192v-.956h-2.192V18.736zm-.956 22.308H13.956V19.692h21.352v21.352z"
            })
        ]
    });
}
/* harmony default export */ var transparentAndReasonable = (TransparentAndReasonable);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/goodDebtReliefCompany/icons/personalizedSolutions.tsx


function PersonalizedSolutions() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#12366D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M18.392 23.754v8.557c0 .866.344 1.696.954 2.308.61.612 1.438.956 2.3.957h3.637L22.49 38.38a.652.652 0 00-.008.932.65.65 0 00.928-.008l3.906-3.919a.653.653 0 000-.923l-3.906-3.92a.65.65 0 00-1.103.465.654.654 0 00.183.46l2.794 2.803h-3.636a1.952 1.952 0 01-1.38-.574 1.965 1.965 0 01-.573-1.385v-8.557a4.554 4.554 0 002.898-1.658 4.582 4.582 0 00-.444-6.213 4.549 4.549 0 00-6.21 0 4.578 4.578 0 00-.445 6.213 4.554 4.554 0 002.899 1.658zm.65-7.772A3.248 3.248 0 0122.05 18a3.275 3.275 0 01-.705 3.558 3.252 3.252 0 01-3.548.708 3.258 3.258 0 01-1.46-1.203 3.274 3.274 0 01.405-4.122 3.254 3.254 0 012.3-.958zm18.88 14.435v-8.556a3.274 3.274 0 00-.954-2.308 3.254 3.254 0 00-2.3-.958H31.03l2.795-2.804a.654.654 0 00-.463-1.107.65.65 0 00-.458.184l-3.906 3.918a.652.652 0 000 .924l3.906 3.919a.65.65 0 001.103-.464.654.654 0 00-.182-.46l-2.795-2.804h3.636c.518 0 1.015.207 1.38.575.367.367.573.865.573 1.385v8.556a4.553 4.553 0 00-2.898 1.658 4.582 4.582 0 00.445 6.214 4.549 4.549 0 006.21 0 4.578 4.578 0 00.444-6.214 4.554 4.554 0 00-2.899-1.658zm-.65 7.772a3.248 3.248 0 01-3.008-2.016 3.275 3.275 0 01.706-3.559 3.252 3.252 0 013.547-.708 3.273 3.273 0 011.055 5.325 3.254 3.254 0 01-2.3.958z"
            })
        ]
    });
}
/* harmony default export */ var personalizedSolutions = (PersonalizedSolutions);

;// CONCATENATED MODULE: ./src/components/nomoredebttoday/goodDebtReliefCompany/icons/privacyAndDataSecurity.tsx


function PrivacyAndDataSecurity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56",
        height: "56",
        fill: "none",
        viewBox: "0 0 56 56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "27.859",
                cy: "27.859",
                r: "27.859",
                fill: "#12366D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M40.201 18.126a.605.605 0 00-.465-.487c-.08-.018-8.144-1.818-11.786-3.579a.604.604 0 00-.526 0c-3.641 1.761-11.705 3.562-11.787 3.58a.605.605 0 00-.464.486c-.008.044-.685 4.796.696 10.439 1.678 6.856 5.681 11.83 11.577 14.386a.614.614 0 00.48 0c5.897-2.556 9.9-7.53 11.578-14.387 1.382-5.642.705-10.394.697-10.438zm-1.87 10.151c-1.585 6.474-5.166 11-10.644 13.459-5.479-2.459-9.06-6.986-10.644-13.459-1.082-4.422-.84-8.335-.723-9.553 1.695-.39 7.973-1.89 11.367-3.452 3.393 1.562 9.671 3.061 11.367 3.451.117 1.22.36 5.132-.724 9.554z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.89 20.069a111.46 111.46 0 01-3.6-.954.604.604 0 10-.33 1.162c1.019.289 2.089.575 3.186.85a28.108 28.108 0 01-.164 3.078.605.605 0 001.202.13c.134-1.23.19-2.471.166-3.692a.604.604 0 00-.46-.574zM31.01 25.48h-6.646c-1 0-1.813.812-1.813 1.812v4.833c0 1 .814 1.812 1.813 1.812h6.646c1 0 1.812-.813 1.812-1.812v-4.833c0-1-.813-1.813-1.812-1.813zm.604 6.645c0 .333-.27.604-.604.604h-6.646a.604.604 0 01-.604-.604v-4.833c0-.334.27-.605.604-.605h6.646c.333 0 .604.271.604.605v4.833zM24.666 24.875c.334 0 .604-.27.604-.604a2.42 2.42 0 012.417-2.417 2.42 2.42 0 012.416 2.417.604.604 0 101.209 0c0-2-1.626-3.625-3.625-3.625-2 0-3.625 1.625-3.625 3.625 0 .334.27.604.604.604z"
            })
        ]
    });
}
/* harmony default export */ var privacyAndDataSecurity = (PrivacyAndDataSecurity);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/nomoredebttoday/goodDebtReliefCompany/index.tsx








const UnlockAdvantagesList = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(accreditationFromIndustry, {}),
        description: "Accreditation from industry organizations such as the American Fair Credit Council (AFCC) or the International Association of Professional Debt Arbitrators (IAPDA) strongly indicates credibility"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(transparentAndReasonable, {}),
        description: "Transparent and reasonable fees and a clear explanation of the cost structure are crucial to avoiding unexpected expenses"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(personalizedSolutions, {}),
        description: "A good debt relief company should offer personalized solutions tailored to your unique financial situation and needs"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyAndDataSecurity, {}),
        description: "They should prioritize your privacy and data security and provide excellent customer support throughout the debt relief process"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyAndDataSecurity, {}),
        description: "They should prioritize your privacy and data security and provide excellent customer support throughout the debt relief process"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(severalKeyFactors, {}),
        description: "Reading client reviews and testimonials can also offer valuable insights into the company's reputation and customer satisfaction."
    }, 
];
function GoodDebtReliefCompany() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row lg:gap-20 gap-12 lg:mt-24 mt-12 lg:mb-48 mb-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[700px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-10 text-[#253F91] text-center sm:text-left",
                        children: "What Should You Seek in a Good Debt Relief Company?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "lg:text-xl lg:leading-8 lg:mt-12 mt-16 text-center sm:text-left",
                        children: "Several key factors should be on your checklist when searching for a reputable debt relief company. These include:"
                    }),
                    UnlockAdvantagesList.map((advantage, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-10 first-of-type:mt-8 flex flex-col sm:flex-row lg:gap-7 gap-5 items-center ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: advantage.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "lg:text-xl lg:leading-8 text-center sm:text-left",
                                    children: advantage.description
                                })
                            ]
                        }, index))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " w-[487px] min-w-[487px] h-[625px] relative mt-24 hidden lg:block ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/nomoredebttoday/assets/images/goodDebtReliefImg.jpg",
                    alt: "Image",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ }),

/***/ 80761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47168);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47496);
/* harmony import */ var _styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);









function MainBanner() {
    const { visitDetails , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["checkbox-field"]),
                        all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().field),
                        input: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["input-field"])
                    },
                    fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"]),
                    fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-note"]),
                    fieldErrorMessageClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-error-message"]),
                    sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["selling-point"]),
                    formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["progress-background"])
                },
                colors: {
                    primaryColor: (_styles_variables_homewarrantyestimateVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().mainColor),
                    progressBar: "#B3B3B3"
                },
                showProgress: true,
                goToThankYouPage: false,
                sellingPoint: visitDetails?.region ? `${visitDetails?.region}'s Best Debt Relief Companies` : "",
                sellingPointsSteps: "FIRST_STEP",
                dynamicThankYouFields: [
                    "firstName"
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 78678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50049);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton() {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `bg-[#0288cc] color-[#ffffff]  py-4 sm:px-16 px-4 sm:text-lg font-semibold rounded-[13px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)} `,
        children: "Get My Free Debt Relief Consultation Now"
    });
}


/***/ }),

/***/ 57384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhySeekDebtRelief; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78678);




function WhySeekDebtRelief() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-40 gap-8 lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[550px] mx-auto lg:mx-0 order-2 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-[#253F91] ",
                        children: "Why Should You Seek Debt Relief?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                        children: "Debt relief companies are experts in helping people who feel overwhelmed by unmanageable debt. Their main aim is to provide practical solutions to ease financial burdens. They typically offer services like negotiating with creditors to reduce the total amount owed, consolidating debts into a single manageable payment, providing credit counseling to educate clients about managing money, and assisting with bankruptcy proceedings if needed."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: "These companies work closely with clients to create personalized plans for repaying debt, negotiate lower interest rates, and explore legal options for relief. The ultimate goal is to help individuals regain control of their finances and move towards a debt-free future."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sm:mt-6 mt-3 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[221px] h-[253px] md:w-[500px] md:min-w-[500px] md:h-[600px] relative mx-auto lg:mx-0 order-1 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/nomoredebttoday/assets/images/whySeekImg.png",
                    alt: "Image",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 64777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__je3rM"};

/***/ }),

/***/ 22950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"style_mainSection__VFhth"};

/***/ }),

/***/ 47168:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","selling-point":"styles_selling-point__KW5yT","main-banner":"styles_main-banner__z_IVw","form":"styles_form__2akl1","step":"styles_step__wsvz0","form-field":"styles_form-field__Um8yg","step-title":"styles_step-title__NX_cC","steps-inner":"styles_steps-inner__DhAkF","label-as-step-title":"styles_label-as-step-title___qNGU","step-description":"styles_step-description__y0vYJ","fields-wrapper":"styles_fields-wrapper__L_I_m","form-button":"styles_form-button___NbHW","radio-field":"styles_radio-field__GEXtR","checkbox-field":"styles_checkbox-field__1j2jZ","field-note":"styles_field-note__FNSxq","input-field":"styles_input-field__f4y9g","field-error-message":"styles_field-error-message__bwBvc","field":"styles_field__EIn_l","tcpa":"styles_tcpa__UvY0n","image":"styles_image__UUCPt"};

/***/ }),

/***/ 50049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__df3FA"};

/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ }),

/***/ 47496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#244880","paragraphColor":"#232323"};

/***/ })

}]);